import { Button, ButtonGroup, SVGWrapper } from '@tracsis/library/src';
import {
	Chevron,
	Cross,
	TableOfContents,
} from '@tracsis/library/src/components/Icon';
import { ThemeContext } from '@tracsis/library/src/context/ThemeContext';
import cx from 'classnames';
import scrollTo from 'gatsby-plugin-smoothscroll';
import React, { useContext, useEffect, useState } from 'react';

import * as styles from './Subnavigation.module.css';

const SubNavigation = ({
	toc,
	tocTitle,
	activeHeading,
}: {
	toc: {
		to: string;
		label: string;
		id: string;
	}[];
	tocTitle?: string;
	activeHeading: string | null;
}) => {
	const isBrowser = typeof window !== 'undefined';
	const { mobileMenuContext } = useContext(ThemeContext);
	const [tocState, setTocState] = useState(false);

	function toggleToc() {
		setTocState((tocState) => !tocState);
	}

	useEffect(() => {
		setTocState(false);
	}, [mobileMenuContext]);

	return (
		<div className={styles.toc}>
			<nav className={cx(styles.tocNav, tocState ? styles.tocNavOpen : null)}>
				{tocTitle && <h3 className={styles.title}>{tocTitle}</h3>}
				<ButtonGroup spacing="lg" className={styles.tocButtonGroup}>
					<Button
						onClick={toggleToc}
						theme="lightblue"
						className={styles.tocButton}>
						Contents {tocState ? <Cross /> : <TableOfContents />}
					</Button>
				</ButtonGroup>
				<ul>
					{toc.map(
						(
							{ label, to, id }: { label: string; to: string; id: string },
							i: number
						) => (
							<li key={i}>
								<a
									href=""
									className={cx(styles.link, {
										[styles.active]: activeHeading === id,
									})}
									onClick={(e) => {
										e.preventDefault();
										scrollTo(`section#${id}`);
										toggleToc();
									}}>
									<SVGWrapper
										height="0.75rem"
										width="0.75rem"
										className={styles.icon}>
										<Chevron />
									</SVGWrapper>
									{label}
								</a>
							</li>
						)
					)}
				</ul>
			</nav>
		</div>
	);
};

export default SubNavigation;
